<template>
  <div class="following-section">
    <h4 class="heading squiggly-line-color">Wishlist</h4>
    <div class="subscribed-courses" v-if="getWishlist.length !== 0">
      <b-row>
        <b-col
          md="6"
          lg="4"
          xl="3"
          v-for="course in getWishlist"
          :key="course.name"
        >
          <course-template :courseData="course" v-if="getWishlist" />
          <ContentLoader v-else :height="450" class="course-card">
          </ContentLoader>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <no-content
        :button-text="buttonText"
        :message="message"
        :is-course="true"
      ></no-content>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CourseTemplate from "../components/Templates/CourseTemplate";
import NoContent from "../components/Templates/NoContent";

export default {
  components: {
    NoContent,
    CourseTemplate
  },
  name: "wishlist",
  data() {
    return {
      buttonText: "View All Courses",
      message: " Wishlist is Empty"
    };
  },
  computed: {
    ...mapGetters("user", ["getWishlist"])
  }
};
</script>

<style scoped></style>
